import {
    Button,
    Card,
    CardContent,
    Grid,
    Tooltip,
    Typography,
} from '@mui/material';
import { ICardLine } from './ICardLine';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CustomisedLoadFile from '../loadFile/loadFile';
import { ICardUpload } from './ICardUpload';
import { useMutation, useQueryClient } from 'react-query';
import { removeDocument } from '../../services/residential.service';
import { IDocumentRequest } from '../../models/identity.model';
import { REFRENCE_KEY } from '../../config/cacheKey';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useEffect, useState } from 'react';
import ConfirmDeleteModal from '../modal/confirmDeleteModal';

export default function CustomisedCardLoad({
    title,
    comment,
    fileSelected,
    documentId,
    setDelImage,
    setChildValue,
    fileArray,
    serviceName,
    serviceRequestObj,
    rejected,
    checkBySetad,
    functionCheque,
    fileType
}: ICardUpload) {
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const queryClient = useQueryClient();
    const getRefrencekey = queryClient.getQueryData(REFRENCE_KEY);
    useEffect(() => {
        if (confirm === true) {
            removeDocument();
            if (functionCheque) {

                functionCheque();
            }
        }
    }, [confirm])
    function deleteImage() {
        setOpenVerifyModal(true);
    }

    function removeDocument() {
        if (serviceRequestObj) {
            RemoveDocumentMutate(serviceRequestObj);
            setChildValue(fileArray);
        } else {
            setChildValue(fileArray);
        }
    }


    const { mutate: RemoveDocumentMutate } = useMutation(serviceName, {
        onSuccess: (data: boolean) => {
            if (data) {
                setDelImage(data!);
            }
        },
    });
    const [openTooltip, setOpenTooltipValue] = useState(null);
    const toggleClick = (index: any) => {
        setOpenTooltipValue(openTooltip === index ? null : index);
    };
    return (
        <>
            <Card
                className={`${rejected === true ? 'rejectCardBorderDesign' : rejected === false ? 'acceptCardBorderDesign' : 'cardBorderDesign'} !shadow-none`}
                style={{
                    height: 'fit-content',
                    marginBottom: '10px',
                    background: 'var(--input-bg-color)',
                    borderRadius: '8px',
                    border: '1px solid var(--border-color)',
                }}
            >
                <CardContent style={{ height: '100%', padding: '9px' }}>
                    <Grid container style={{ height: '100%', alignItems: 'center' }}>
                        <Grid item xs={7}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <div
                                    // onClick={() => ontouchstart}
                                    >
                                        <p className="text-[#212121] font-bold mr-1 mb-5 mt-3">
                                            <Tooltip
                                                onClose={() => toggleClick(null)}
                                                open={openTooltip === 0}
                                                placement="bottom-start"
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            width: '165px',
                                                            textAlign: 'center',
                                                            fontSize: '11px',
                                                            marginRight: '11vh',
                                                            marginLeft: '1vh',
                                                        },
                                                    },
                                                }}
                                                title={comment + " "}
                                                arrow
                                            >
                                                <Button className="!text-sm !font-bold text-[#212121] mb-1 items-center buttonCard primaryColorLight-900
"
                                                    onClick={() => toggleClick(0)} style={{ background: 'transparent' }} disableTouchRipple>
                                                    {title}
                                                    <InfoOutlinedIcon
                                                        className="primaryColorLight mr-2"
                                                        style={{
                                                            width: '17px',
                                                            height: '17px',
                                                        }}
                                                    />
                                                </Button>
                                            </Tooltip>
                                        </p>
                                    </div>
                                </Grid>
                                {
                                    // checkBySetad === false || checkBySetad === undefined || (rejected === true || rejected === undefined) ?
                                    ((checkBySetad === undefined || checkBySetad === true) && (rejected === true || rejected === undefined)) ||
                                        ((checkBySetad === undefined || checkBySetad === false) && (rejected === false || rejected === undefined)) ?
                                        <>
                                            <Grid item xs={12}>
                                                <hr className="ml-3" />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button onClick={() => deleteImage()}>
                                                    <p
                                                        className="font-bold primaryColorLight-900 mt-2"
                                                        style={{ fontSize: '12.5px' }}
                                                    >
                                                        <DeleteOutlineIcon />
                                                        حذف و بارگذاری مجدد
                                                    </p>
                                                </Button>
                                            </Grid>
                                        </> : ""
                                }
                            </Grid>
                        </Grid>
                        <Grid item xs={5} style={{ height: '13vh' }}>
                            <CustomisedLoadFile fileUrl={fileSelected} fileType={fileType} />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <ConfirmDeleteModal text={"آیا از حذف این مدرک اطمینان داید؟"}
                buttonTitle={'حذف'}
                delButton={true}
                openModal={openVerifyModal}
                setOpenVerifyModal={setOpenVerifyModal}
                setConfirm={setConfirm}
            />
        </>
    );

}
